import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "../../../components/UpdateUi/SubHeader/SubHeader";
import Button from "../../components/CustomButtons/Button";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import brandTheme from "brandTheme/Theme";
import ToastModal from "views/components/ToastModal";
import { saveUserAddharTransationDetails } from "store/reducers/login/LoginSlice";
import { demoLoanList } from "assets/properties/properties";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";
import { isValidRequiredValue } from "utils/Utils";
import { isValidAlphabetValue } from "utils/Utils";
import { isValidPincode } from "utils/Utils";
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  verifyButton: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: 0,
  },
  nextButton3: {
    boxShadow: "inherit",
    color: brandTheme.white,
    padding: "0px 40px",
    height: "55px",
    width: "8%",
    background: "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    "&:hover": {
      background: "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      boxShadow: "inherit",
    },
    "&:focus": {
      background: "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      boxShadow: "inherit",
    },
  },
}));

const AadharDetails = () => {
  const location = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const [aadharNumber, setAadharNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [enableOtpField, setEnabledOtpField] = useState(false);
  const [enableAadharField, setEnabledAadharField] = useState(false);
  const [showVerifyButton, setShowVerifyButton] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [showCompleteAadharMessage, setShowCompleteAadharMessage] =
    useState(false);
  const [pollingInterval, setPollingInterval] = useState(null);
  const [redirectUrl,setRedirectUrl] = useState('');
  const [purposeOfloan, setPurposeOfLoan] = useState(demoLoanList?.[0]?.value);
  const [applicantAddressId, setApplicantAddressId] = useState(null);
  const [aadharAddressData, setAadharAddressData] = useState({
    adhaarNumber: "",
    maskedAdhaarNumber: "",
    fatherName: "",
    dob: "",
    houseNumber: "",
    street: "",
    locality: "",
    villageTownCity: "",
    postOffice: "",
    state: "",
    district: "",
    pincode: "",
  });

  const [editableFields, setEditableFields] = useState({
    fatherName: false,
    dob: false,
    houseNumber: false,
    street: false,
    locality: false,
    villageTownCity: false,
    postOffice: false,
    state: false,
    district: false,
    pincode: false,
  });
  const actualLEadList={};
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    if(aadharAddressData?.pincode){
      checkForBlackListPincode(aadharAddressData?.pincode);
    }
  },[]);
  const checkForBlackListPincode = async (formattedPincodes) => {
      setCallInProgress(true);
      try {
        const res = await apiHandler({
          url: endpoint.MASTER_BLACK_LIST_PINCODE_FIND_BY_PINCODE + formattedPincodes,
          method: "GET",
          authToken: authToken,
        });
        if (res?.data?.error_code) {
          toastUpdate("Error",res?.data?.user_description,true)
        } else {
          if(res?.data?.blacklisted){
            setEnabledAadharField(false);
            toastUpdate(
              "Error",
              "Delivery is currently unavailable for this pincode. Please enter a different pincode or contact support.",
              true
            );
          }else{
            setEnabledAadharField(true);
          }
        }
      } catch (error) {
        console.error("Error fetching branch details:", error);
      } finally {
        setCallInProgress(false);
      }
    }
  useEffect(() => {
    if (aadharNumber?.length === 12) {
      setShowVerifyButton(true);
    }
  }, [aadharNumber]);

  useEffect(() => {
    if (location.state?.data?.error_code) {
      toastUpdate(
        "Error",
        location.state.data.user_description,
        true
      );
      return;
    }
  
    getAadharAddressDetails();
  }, [enableAadharField]);
  useEffect(() => {
    return () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };
  }, [pollingInterval]);
  const verifyAadharInitiator = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.AADHAR_KYC_INITIATE_API,
      method: "POST",
      authToken: authToken,
      data: {
        leadApplicationId: leadId,
        redirectUrl: window.location.origin + '/journey/aadhar-oauth',
        reInitiateKyc: true,
        adhaarNumber: aadharNumber,
      },
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    }else if (result?.data?.url) {
      setTransactionId(result?.data?.transactionId);
      setRedirectUrl(result?.data?.url);
      const { transactionId, url } = result.data;
      dispatch(
        saveUserAddharTransationDetails(
          {
            transationId: transactionId,
          }
        )
      )
      window.location.href = url;
    } else {
      setTransactionId(result?.data?.transactionId);
      setEnabledOtpField(true);
    }
  };
  const validateOtp = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.AADHAR_KYC_DETAILS_API,
      method: "POST",
      authToken: authToken,
      data: {
        transactionId: transactionId,
        otp: otp,
      },
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      toastUpdate("Success","Aadhar authentication successfull",true)
      setEnabledAadharField(true);
    }
  };

  const getAadharAddressDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.AADHAR_KYC_DETAILS_API + "/" + leadId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      // toastUpdate("Error", result?.data?.user_description, true);
    } else {
      if (result?.data !== "") {
        setEnabledAadharField(true);
        setAadharDataFromApi(result?.data);
      }
    }
  };
  const setAadharDataFromApi = (data) => {
  setApplicantAddressId(data?.applicantAddressId);

  const fields = {
    adhaarNumber: data?.adhaarNumber,
    maskedAdhaarNumber: data?.maskedAdhaarNumber,
    fatherName: data?.fatherName,
    dob: data?.dob,
    houseNumber: data?.houseNumber,
    street: data?.street,
    locality: data?.locality,
    villageTownCity: data?.villageTownCity,
    postOffice: data?.postOffice,
    state: data?.state,
    district: data?.district,
    pincode: data?.pincode,
  };

  const nextData = {};
  const nextEditableFields = {};

  Object.keys(fields).forEach((field) => {
    const value = fields[field];

    if (field === "adhaarNumber" || field === "maskedAdhaarNumber") {
      nextData[field] = value || "";
      return;
    }

    let isValid = isValidRequiredValue(value);

    if (field === "villageTownCity") {
      isValid = isValidAlphabetValue(value);
    }

    if (field === "postOffice") {
      isValid = isValidAlphabetValue(value);
    }

    if (field === "pincode") {
      isValid = isValidPincode(value);
    }

    if (isValid) {
      nextData[field] = value;
      nextEditableFields[field] = false;
    } else {
      nextData[field] = "";
      nextEditableFields[field] = true;
    }
  });

  setAadharAddressData((prev) => ({
    ...prev,
    ...nextData,
  }));

  setEditableFields((prev) => ({
    ...prev,
    ...nextEditableFields,
  }));
};
  useEffect(()=>{
    if(transactionId && redirectUrl){
      openHtmlInNewTab(redirectUrl);
    }
  },[transactionId,redirectUrl]);

  const openHtmlInNewTab = (url) => {
    runApiInInterval();
  };

  const runApiInInterval = () => {
    const interval = setInterval(async () => {
      const result = await apiHandler({
        url: endpoint.AADHAR_KYC_DETAILS_API,
        method: "POST",
        authToken: authToken,
        data:{
          transactionId: transactionId,
        }
      });

      if (!result?.data?.error_code && result?.data !== "") {
        toastUpdate("Success","Aadhar authentication successfull",true);
        clearInterval(interval);
        setPollingInterval(null);
        setShowCompleteAadharMessage(false);
        setEnabledAadharField(true);
        setAadharDataFromApi(result?.data);
      }
    }, 5000);

    setPollingInterval(interval);
  };
  const handleNext = async () => {
  setCallInProgress(true);

  try {
    // First update Aadhaar details
    const updateSuccess = await updateAadharDetails();

    if (!updateSuccess) {
      return;
    }

    // Then existing eligibility API
    const result = await apiHandler({
      url: endpoint.GET_CUSTOMER_ELIGIBILITY + leadId,
      method: "POST",
      authToken: authToken,
    });

    if (result?.data?.error_code) {
      toastUpdate(
        "Error",
        result?.data?.user_description,
        true
      );
      return;
    }

    const data = result?.data;

    if (
      data?.decision?.trim()?.toLowerCase() === "reject" ||
      data?.decision?.trim()?.toLowerCase() === "rejected"
    ) {
      navigate("/loanRejected");
      return;
    }

    navigate("/journey/BankAnalyser");
  } catch (error) {
    console.error("Error updating Aadhaar details:", error);

    toastUpdate(
      "Error",
      "Unable to update Aadhaar details",
      true
    );
  } finally {
    setCallInProgress(false);
  }
};
  const updateAadharDetails = async () => {
  const payload = {
    leadApplicationId: leadId,

    fatherName: aadharAddressData?.fatherName,
    dob: aadharAddressData?.dob,
    houseNumber: aadharAddressData?.houseNumber,
    street: aadharAddressData?.street,
    locality: aadharAddressData?.locality,
    villageTownCity: aadharAddressData?.villageTownCity,
    postOffice: aadharAddressData?.postOffice,
    state: aadharAddressData?.state,
    district: aadharAddressData?.district,
    pincode: aadharAddressData?.pincode,
  };

  const result = await apiHandler({
    url:
      endpoint.UPDATE_AADHAR_DETAILS +
      "/" +
      applicantAddressId,
    method: "PUT",
    authToken: authToken,
    data: payload,
  });

  if (result?.data?.error_code) {
    toastUpdate(
      "Error",
      result?.data?.user_description || "Unable to update Aadhaar details",
      true
    );

    return false;
  }

  return true;
};
  const handleAadharFieldChange = (field, value) => {
  if (
    (field === "postOffice" || field === "villageTownCity") &&
    value &&
    !/^[A-Za-z\s]*$/.test(value)
  ) {
    return;
  }
  if (field === "pincode") {
    if (!/^\d*$/.test(value) || value.length > 6) {
      return;
    }
  }
  setAadharAddressData((prev) => ({
    ...prev,
    [field]: value,
  }));
};
const areAllAadharFieldsValid = () => {
  const data = aadharAddressData;

  const requiredFieldsValid =
    isValidRequiredValue(data?.fatherName) &&
    isValidRequiredValue(data?.dob) &&
    isValidRequiredValue(data?.houseNumber) &&
    isValidRequiredValue(data?.street) &&
    isValidRequiredValue(data?.locality) &&
    isValidAlphabetValue(data?.villageTownCity) &&
    isValidAlphabetValue(data?.postOffice) &&
    isValidRequiredValue(data?.state) &&
    isValidRequiredValue(data?.district) &&
    isValidPincode(data?.pincode);

  return requiredFieldsValid;
};
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader
          label="Aadhar Details"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          {showCompleteAadharMessage ? (
            <Grid
              item
              xs={12}
              style={{ textAlign: "center", margin: "20px 0" }}
            >
              <p style={{ color: brandTheme.lightBlue, fontWeight: "bold" }}>
                Please complete Aadhaar verification in the newly opened tab...
              </p>
            </Grid>
          ) : (
            <>
              {!enableAadharField && (
                <>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                    style={{ position: "relative" }}
                  >
                    <CustomTextField
                      label="Aadhar Number"
                      placeholder="Enter 12 digit Number"
                      value={aadharNumber}
                      onChange={(e) => setAadharNumber(e.target.value)}
                      style={classes.inputField}
                      type="number"
                      maxLength="12"
                      disabled={enableOtpField}
                    />
                    <Button
                      className={`${classes.verifyButton} ${classes.nextButton3}`}
                      size="small"
                      onClick={() => verifyAadharInitiator()}
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        margin: 0,
                      }}
                      disabled={enableOtpField}
                    >
                      Verify
                    </Button>
                  </Grid>
                  {enableOtpField && (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      className={classes.fieldContaienr}
                      style={{ position: "relative" }}
                    >
                      <CustomTextField
                        label="Aadhar OTP"
                        placeholder="Enter 6 digit OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        style={classes.inputField}
                        type="number"
                        maxLength="6"
                        disabled={enableAadharField}
                      />
                      <Button
                        className={`${classes.verifyButton} ${classes.nextButton3}`}
                        size="small"
                        onClick={() => validateOtp()}
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          margin: 0,
                        }}
                        disabled={enableAadharField}
                      >
                        Verify
                      </Button>
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  ></Grid>
                </>
              )}
              {enableAadharField && (
                <>
                {/* <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                  <CustomSelect
                    label="ApplicantStatus"
                    value={purposeOfloan}
                    onChange={(e) => setPurposeOfLoan(e.target.value)}
                    options={demoLoanList}
                    style={classes.documentSelectBox}
                  />
                </Grid> */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="Masked Aadhar Number"
                      placeholder="Masked Aadhar Number"
                      value={
                        (aadharAddressData?.maskedAdhaarNumber ||
                          aadharAddressData?.adhaarNumber)
                          ?.toString()
                          ?.replace(/\d(?=\d{4})/g, "*")
                      }
                      style={classes.inputField}
                      disabled={true}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="Father Name"
                      placeholder="Father Name"
                      value={aadharAddressData?.fatherName}
                      onChange={(e) =>
                        handleAadharFieldChange("fatherName", e.target.value)
                      }
                      style={classes.inputField}
                      disabled={!editableFields.fatherName}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="Date Of Birth"
                      placeholder="Date Of Birth"
                      value={aadharAddressData?.dob}
                      style={classes.inputField}
                      disabled={true}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="House Number"
                      placeholder="House Number"
                      value={aadharAddressData?.houseNumber || ""}
                      onChange={(e) =>
                        handleAadharFieldChange("houseNumber", e.target.value)
                      }
                      style={classes.inputField}
                      disabled={!editableFields.houseNumber}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="Street"
                      placeholder="Street"
                      value={aadharAddressData?.street || ""}
                      onChange={(e) =>
                        handleAadharFieldChange("street", e.target.value)
                      }
                      style={classes.inputField}
                      disabled={!editableFields.street}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="Locality"
                      placeholder="Locality"
                      value={aadharAddressData?.locality || ""}
                      onChange={(e) =>
                        handleAadharFieldChange("locality", e.target.value)
                      }
                      style={classes.inputField}
                      disabled={!editableFields.locality}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                   <CustomTextField
                      label="Village/Town/City"
                      placeholder="Village/Town/City"
                      value={aadharAddressData?.villageTownCity || ""}
                      onChange={(e) =>
                        handleAadharFieldChange("villageTownCity", e.target.value)
                      }
                      style={classes.inputField}
                      disabled={!editableFields.villageTownCity}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="Post Office"
                      placeholder="Post Office"
                      value={aadharAddressData?.postOffice || ""}
                      onChange={(e) =>
                        handleAadharFieldChange("postOffice", e.target.value)
                      }
                      style={classes.inputField}
                      disabled={!editableFields.postOffice}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="State"
                      placeholder="State"
                      value={aadharAddressData?.state || ""}
                      onChange={(e) =>
                        handleAadharFieldChange("state", e.target.value)
                      }
                      style={classes.inputField}
                      disabled={!editableFields.state}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="District"
                      placeholder="District"
                      value={aadharAddressData?.district || ""}
                      onChange={(e) =>
                        handleAadharFieldChange("district", e.target.value)
                      }
                      style={classes.inputField}
                      disabled={!editableFields.district}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomTextField
                      label="Pincode"
                      placeholder="Pincode"
                      value={aadharAddressData?.pincode || ""}
                      onChange={(e) =>
                        handleAadharFieldChange("pincode", e.target.value)
                      }
                      style={classes.inputField}
                      disabled={!editableFields.pincode}
                      type="text"
                      inputProps={{ maxLength: 6 }}
                    />
                  </Grid>
                </>
              )}
            </>
          )}
        </Grid>
      </Grid>
       <Grid item xs={12}>
        <BottomButton
          button1={"Next"}
          button1click={handleNext}
          disabled1={!enableAadharField || !areAllAadharFieldsValid()}
        />
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default AadharDetails;
